module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm03_title"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0003-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("By The Topps Company, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('strong', [_vm._v("Introduction by Art Spiegelman"), _c('br'), _vm._v("Afterword by John Pound")])]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('strong', [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.abramsbooks.com/abrams-comicarts.html",
      "target": "_blank"
    }
  }, [_vm._v("Abrams ComicArts")])]), _vm._v(", New York")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6317b362","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_title.vue
// module id = 66
// module chunks = 0